import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';
import '../../styles/index.scss';
import { authorizeGoogle } from '../../api/userApi';
import { loginUser } from '../../redux/actions';
import history from '../../history';

function getInitialButtonWidth() {
	if (typeof window === 'undefined') return 400;
	const isNarrow = window.innerWidth <= 480;
	return isNarrow ? 320 : 400;
}

class SocialLinks extends Component {
	state = { buttonWidth: getInitialButtonWidth() };

	containerRef = React.createRef();

	componentDidMount() {
		this.updateWidth();
		window.addEventListener('resize', this.updateWidth);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWidth);
	}

	updateWidth = () => {
		if (!this.containerRef.current) return;
		const w = this.containerRef.current.getBoundingClientRect().width;
		const isNarrow = typeof window !== 'undefined' && window.innerWidth <= 480;
		const maxW = isNarrow ? 320 : 400;
		const next = Math.min(Math.max(w, 280), maxW);
		this.setState((prev) => (prev.buttonWidth !== next ? { buttonWidth: next } : null));
	};

	googleAuthorize(data) {
		this.props.setLoading && this.props.setLoading(true);
		authorizeGoogle(data)
			.then((resp) => {
				this.props.loginUser(resp.data.user);
				this.props.setLoading && this.props.setLoading(false);
				history.push(this.props.redirectUrl || '/');
			})
			.catch((error) => {
				this.props.setLoading && this.props.setLoading(false);
				console.warn('Google login error', error?.response?.data || error);
			});
	}

	authorizeFailure() {
		this.props.setLoading && this.props.setLoading(false);
	}

	render() {
		const { buttonWidth } = this.state;
		return (
			<div className="login-google-wrapper" ref={this.containerRef}>
				<GoogleLogin
					onSuccess={(res) => this.googleAuthorize({ tokenId: res.credential })}
					onError={() => this.authorizeFailure()}
					theme="filled_blue"
					size="large"
					width={buttonWidth}
					text="signin_with"
					logo_alignment="left"
					shape="rectangular"
				/>
			</div>
		);
	}
}

const mapStateToProps = ({currentUser}) => {
	return {
		currentUser
	};
};

const mapDispatchToProps = {
	loginUser
};

export default connect(mapStateToProps, mapDispatchToProps)(SocialLinks);
